import { gql } from '@/lib/graphql/gql'

export const COMPANY_FREEZE_QUERY = gql`
  query CompanyFreeze($idCompany: String!) {
    company(id: $idCompany) {
      id
      frozenAt
      frozenReason
    }
  }
`
